// Shared display thresholds for consolidated performance (normalized to 0..1).
// These are presentation ranges, not certification or KPI alert rules.
export const performanceRanges = [
  { minimum: .9, tone: 'good', label: 'Satisfaisant' },
  { minimum: .75, tone: 'watch', label: 'Vigilance' },
  { minimum: .5, tone: 'risk', label: 'En difficulté' },
  { minimum: 0, tone: 'critical', label: 'Critique' },
] as const;
export function performanceStatus(value: number | null | undefined) {
  const score = typeof value === 'number' && Number.isFinite(value) && value >= 0 ? Math.min(1, value) : null;
  if (score === null) return { score, tone: 'unknown', label: 'Non calculé' } as const;
  return { score, ...performanceRanges.find(range => score >= range.minimum)! };
}

/** Missing scores sort after measured scores in either direction; zero is measured. */
export function comparePerformance(a: number | null | undefined, b: number | null | undefined, highestFirst = false) {
  const left = performanceStatus(a).score, right = performanceStatus(b).score;
  if (left === null) return right === null ? 0 : 1;
  if (right === null) return -1;
  return highestFirst ? right - left : left - right;
}
